/* Finished stock routes shared with the server through product metadata. */
(function () {
  'use strict';
  function routes() {
    var node = document.getElementById('hw-stock-routes');
    return JSON.parse(node && node.textContent || '{}');
  }
  window.BGStockHardware = {
    enabled: function () { return Object.keys(routes()).length > 0; },
    route: function (selection, color, codes) {
      if (selection.adaptor !== 'none') return null;
      return routes()[[codes[color] || color, selection.suspension,
        String(parseInt(selection.length, 10)), selection.ceiling].join('|')] || null;
    },
    addFee: function (items, route, parent, quantity, link) {
      if (!route || !route.fee_variant_id) return;
      items.push({ id: Number(route.fee_variant_id), quantity: quantity,
        role: 'pricing', unitsPerParent: 1,
        properties: link({ '_Stock Hardware SKU': route.sku,
          '_Hardware Build Required': 'false', '_Hide From Cart': 'true',
          For: parent.productTitle || parent.title || '',
          'Hardware Color': route.configuration.split(' - ')[0] }, parent) });
    }
  };
}());
